import { Component, OnChanges, OnInit, Input, Output, EventEmitter, Optional, SimpleChanges } from '@angular/core';
import { IDropdownOption, IDropdownEventType, Dropdown, DropdownOption } from './multiselect-dropdown-model';
import { NgControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-multiselect-dropdown-component',
  templateUrl: './multiselect-dropdown-component.component.html'
})
export class MultiselectDropdownComponentComponent implements OnChanges, OnInit {

  @Input() ddData: Dropdown; // To get the data for the dropdown
  @Input() dropdownClassName = '';
  @Input() isDisabled = false; // Defines the enable/disable value of the dropdown
  @Input() showImg: boolean; // Defines the icon requirement on the dropdown
  @Input() formControlObject: FormControl;
  @Input() initialSelectedCount?: number;
  @Input() defaultSelectText?: string;
  @Input() initialLoad?: boolean;
  @Output() onSelectedChange = new EventEmitter<IDropdownEventType>(); // Emits the events when the dropdown options are selected
  @Output() selectedValues: Array<IDropdownOption> = [];
  @Input() isErrorState: false;  // Binds the error state
  @Input() dropdownMenuWidth?: string; // optional input to provide exclusive width for dropdown menu
  @Input() sortData: boolean; // To sort data or not
  @Input() searchData: boolean;
  filterSearch: string;
  previousSelectedValues: Array<string> = [];
  selectedOptions: Array<IDropdownOption> = [];
  selectedOptionText = '';
  optionsCount = 0;
  toggleAllText = '';
  toggleAllClass = false;
  disableAllCheckbox = false;
  value = '';
  ddDataSource: Dropdown;
  @Input() id: number;

  constructor(@Optional() private ngControl: NgControl) {
   if (ngControl) {
     ngControl.valueAccessor = this;
   }
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.updateSelectedOptions();
    this.updateSelectedOptionText();
  }

  updateSelectedOptions() {
    this.ddDataSource = JSON.parse(JSON.stringify(this.ddData));
    this.previousSelectedValues = [];
    this.selectedOptions = [];
    this.selectedValues = [];
    this.ddData.options.forEach(option => {
        if (option.value && option.value.trim() !== '' && option.isSelected) {
            this.previousSelectedValues.push(option.value);
            this.selectedOptions.push(JSON.parse(JSON.stringify(option)));
            this.selectedValues.push(JSON.parse(JSON.stringify(option.value)));
        }
    });
    this.disableAllCheckbox = this.ddData.options.every(d => d.isSelected);
  }

  updateSelectedOptionText() {
    let text = 'Selected [#count]';

    if (this.selectedValues.length > 0) {
        if (this.selectedValues.length === this.ddData.options.length) {
            text = this.defaultSelectText;
        } else {
            text = text.replace('[#count]', this.selectedValues.length.toString());
        }
    } else {
        text = this.defaultSelectText;
    }
    this.selectedOptionText = text;
    return text;
  }

    updateData(event) {
        this.filterSearch = event;
    }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.ddData !== undefined && !changes.ddData.firstChange && changes.ddData.currentValue === undefined) {
        this.ddData = changes.ddData.previousValue;
    }
    // Error state handling
    if (changes.isErrorState !== undefined && changes.isErrorState.currentValue) {
        if (!this.ddData) {
            this.ddData = new Dropdown();
        }
        this.ddData.options.push({ value: '', name: '-1', isSelected: true, text: 'No records found' });
    }
    if (this.ngControl && this.isDisabled) {
        this.ngControl.control.disable();
    } else if (this.ngControl && !this.isDisabled) {
        this.ngControl.control.enable();
    }
    this.optionsCount = 0;
    this.ddData.options.forEach(option => {
        if (option.isSelected) {
            this._onChange(option.value);
            if (this.ngControl) {
                this.ngControl.control.markAsPristine();
            }
        }
        if (!option.isHeader) {
            this.optionsCount++;
        }
    });

    if (changes.defaultSelectText !== undefined && !changes.defaultSelectText.firstChange &&
        changes.defaultSelectText.currentValue === undefined) {
        this.defaultSelectText = changes.defaultSelectText.previousValue;
    }
    this.updateSelectedOptions();
    this.updateSelectedOptionText();
  }

  isChecked(value) {
    return this.ddData.options.findIndex(d => d.value === value && d.isSelected) > -1;
  }

changeInDropdown(event, name, value, text) {
    this.ddData.options.forEach(option => {
        if (!option.isHeader && option.value && option.value.trim() !== '' && option.value === value) {
            option.isSelected = event.target.checked;
            if (event.target.checked) {
                if (this.selectedValues.findIndex(d => d === value) === -1) {
                this.selectedOptions.push(JSON.parse(JSON.stringify(option)));
                this.selectedValues.push(JSON.parse(JSON.stringify(option.value)));
                }
            } else {
                this.selectedOptions.splice(this.selectedOptions.findIndex(d => d.value === value), 1);
                this.selectedValues.splice(this.selectedValues.findIndex(d => d === value), 1);
            }
        }
    });

    // this.disableAllCheckbox = this.ddData.options.every(d => d.isSelected);
    // Emit the new selection
    this.updateSelectedOptions();
    this.updateSelectedOptionText();
    this.onSelectedChange.emit({
        ddName: name,
        selectedValues: this.selectedValues,
        selectedOptions: this.selectedOptions
    });

    // This is required for Reactive forms *** Do not Delete****
    this._onChange(value);
    this._onTouched();
}

onSelectAllCheckbox(event, name) {
    this.ddDataSource = JSON.parse(JSON.stringify(this.ddData));
    // this.disableAllCheckbox = event.target.checked;
    this.selectedOptions = [];
    this.selectedValues = [];
    // if (event.target.checked) {
    //     this.ddData.options.forEach(o => {
    //         o.isSelected = event.target.checked;
    //         this.selectedOptions.push(JSON.parse(JSON.stringify(o)));
    //         this.selectedValues.push(JSON.parse(JSON.stringify(o.value)));
    //     });
    // }
    this.ddData.options.forEach(o => {
        o.isSelected = event.target.checked;
        this.selectedOptions.push(JSON.parse(JSON.stringify(o)));
        this.selectedValues.push(JSON.parse(JSON.stringify(o.value)));
    });

    this.onSelectedChange.emit({
        ddName: name,
        selectedValues: this.selectedValues,
        selectedOptions: this.selectedOptions
    });
}

isAllCheckboxSelected() {
    this.ddDataSource = JSON.parse(JSON.stringify(this.ddData));
    this.disableAllCheckbox = this.ddData.options.every(d => d.isSelected);
    if (this.disableAllCheckbox) {
        this.selectedOptions = [];
        this.selectedValues = [];
        this.ddData.options.forEach(o => {
            o.isSelected = this.disableAllCheckbox;
            if (this.disableAllCheckbox) {
                if (this.selectedValues.findIndex(d => d === o.value) === -1
                    && o.value && o.value.trim() !== '') {
                    this.selectedOptions.push(JSON.parse(JSON.stringify(o)));
                    this.selectedValues.push(JSON.parse(JSON.stringify(o.value)));
                }
            } else {
                this.selectedOptions.splice(this.selectedOptions.findIndex(d => d.value === o.value), 1);
                this.selectedValues.splice(this.selectedValues.findIndex(d => d === o.value), 1);
            }
        });
    }
    return this.disableAllCheckbox;
}


    // ControlValueAccessor implementation
    // ====================================

    // call if value was changed inside our component
    private _onChange = (_: any) => {

    }
    // call if input was "touched" .. !
    private _onTouched = () => { };

    // incoming change..
    public writeValue(val: any) {
        this.value = val;
    }

    public registerOnChange(fn: (_: any) => void): void { this._onChange = fn; }
    public registerOnTouched(fn: () => void): void { this._onTouched = fn; }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/multiselect-dropdown/multiselect-dropdown-component.component.ts